import { ref, push, set } from 'firebase/database';
import { database } from '../firebaseConfig';

// Builds a hand-added client task. No notification or email fields: mode 'task', never automatic.
export function buildManualTask({ uid, title, dueDate, dueTime = '', notes = '', priority = 'medium', contactId = '', contactName = '', transactionId = '', buyerInterestId = '', sellerInterestId = '' }, now = new Date().toISOString()) {
  const t = String(title || '').trim();
  return {
    name: t, title: t, description: contactName ? `Client: ${contactName}` : '', notes: String(notes || '').trim(),
    role: 'Agent', type: 'To-do', mode: 'task', automatic: false, manual: true,
    source: transactionId ? 'transaction' : 'manual',
    priority,
    ...(contactId ? { crmContactId: contactId, crmContactName: contactName || '' } : {}),
    ...(transactionId ? { transactionId } : {}),
    ...(buyerInterestId ? { buyerInterestId } : {}),
    ...(sellerInterestId ? { sellerInterestId } : {}),
    dueDate, ...(dueTime ? { dueTime, dueAt: new Date(`${dueDate}T${dueTime}`).toISOString() } : {}),
    status: 'pending', assignee: uid, createdAt: now, updatedAt: now, createdBy: uid, completedAt: null,
  };
}

// Deal tasks live on the deal (transactions/{id}/tasks) with role Agent, so the owner and any co-agent both see them
// (the existing co-agent sharing rule). Everything else is the agent's own task (users/{uid}/tasks).
export async function addManualTask(input) {
  const task = buildManualTask(input);
  const path = input.transactionId ? `transactions/${input.transactionId}/tasks` : `users/${input.uid}/tasks`;
  const r = push(ref(database, path));
  await set(r, task);
  return { id: r.key, path, task };
}
